import React from 'react'
import Dashboard from 'views/Dashboard/Dashboard.jsx'

// administration view
import SigningPathDetail from 'views/Administration/SigningPathDetail'
import SigningPathPage from 'views/Administration/SigningPathPage'
import RoutingDetails from '../views/Administration/RoutingDetails'
// import RoutingPage from '../views/Administration/RoutingPage'
import RoutingTable from '../views/Administration/RoutingTable'

// applicatin view
// import RequestSubContractorPaymentPage from 'views/Applications/RequestSubContractorPaymentPage'
import GeneralApplicationTemplate from 'views/Applications/General'
import BusinessTravelApplication from 'views/Applications/BusinessTravel'
import TimeOff from 'views/Applications/TimeOff'
import ApplicationTable from 'views/Applications/ApplicationTable'
import ApplicationTableV2 from 'views/Applications/ApplicationTable-v2'
// import RequestSubContractorPayment from '../views/Applications/RequestSubContractorPayment'

// user views
import UsersAll from 'views/Users/UsersAll'
import UserProfile from 'views/Users/UserProfile'
import UserPasswordReset from 'views/Users/UserPasswordReset'
import UserSettings from 'views/Users/UserSettings'
import DepartmentPage from '../views/Users/DepartmentPage'
import CompanyPage from '../views/Users/CompanyPage'
import UserGroupPage from '../views/Users/UserGroupPage'

// @material-ui/icons
import DashboardIcon from '@material-ui/icons/Dashboard'
import Comment from '@material-ui/icons/Comment'
import AllInclusive from '@material-ui/icons/AllInclusive'
import EventAvailable from '@material-ui/icons/EventAvailable'
import EventBusy from '@material-ui/icons/EventBusy'
import EventNote from '@material-ui/icons/EventNote'
import MyLocation from '@material-ui/icons/MyLocation'
import Add from '@material-ui/icons/Add'
import Settings from '@material-ui/icons/Settings'
import People from '@material-ui/icons/People'
import PeopleOutline from '@material-ui/icons/PeopleOutline'
import PersonAdd from '@material-ui/icons/PersonAdd'
import Bookmark from '@material-ui/icons/Bookmark'
import Bookmarks from '@material-ui/icons/Bookmarks'
import FormatListNumbered from '@material-ui/icons/FormatListNumbered'
import Storage from '@material-ui/icons/Storage'
import SwapCalls from '@material-ui/icons/SwapCalls'
import Share from '@material-ui/icons/Share'
import FolderShared from '@material-ui/icons/FolderShared'
// import WidgetsIcon from '@material-ui/icons/Widgets'
import Brightness1 from '@material-ui/icons/Brightness1'
import Brightness2 from '@material-ui/icons/Brightness2'
import Brightness3 from '@material-ui/icons/Brightness3'
import LooksOne from '@material-ui/icons/LooksOne'
import LooksTwo from '@material-ui/icons/LooksTwo'
import LooksThree from '@material-ui/icons/Looks3'
import Lock from '@material-ui/icons/Lock'
import LockOpen from '@material-ui/icons/LockOpen'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BusinessTravel from '../views/Applications/BusinessTravel'

import ExRates from '../views/Administration/ExRates'

//trying stuff
const UserEnum = {
  SUPER: 0,
  ADMIN: 1,
  USER: 2,
  HRDocumentReceiver: 96,
  ExpenseDocumentReceiver: 97,
  ProcurementDocumentReceiver: 98,
  GUEST: 99
}

// these routes are populated in Dashboard.jsx
export const hiddenRoutes = [
  {
    path: '/user/profile',
    name: 'UserProfile',
    component: UserProfile,
    params: { userSelf: true }
  },
  {
    path: '/user/resetpassword',
    name: 'UserPasswordReset',
    component: UserPasswordReset
  },
  {
    path: '/user/settings',
    name: 'User Settings',
    component: UserSettings
  },
  {
    path: '/systemadmin/update-signingpath',
    name: 'Update Signing Path',
    component: SigningPathDetail
  },
  {
    path: '/systemadmin/update-route',
    name: 'Update Routing',
    component: RoutingDetails
  },
  // for user to click on the edit button in the user table
  {
    path: '/administration/updateuser',
    name: 'Update User',
    component: UserProfile
  },
  {
    path: '/application/gat/:id',
    name: 'General Application',
    title: 'Update General Application',
    component: GeneralApplicationTemplate
  },
  {
    path: '/application/toa/:id',
    name: 'Timeoff Application',
    component: TimeOff
  },
  {
    path: '/application/bta/:id',
    name: 'Business Travel Application',
    title: 'Update Business Travel Application',
    component: BusinessTravel
  },
  {
    path: '/applications/searched',
    name: 'Matching Applications',
    render: props => <ApplicationTable {...props} />
  }
]
var dashRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: Dashboard,
    // render: props => <ApplicationTable {...props} status="inProgress" />, //charts
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ]
  },
  {
    collapse: true,
    path: '/newapplication',
    name: 'Create Application',
    state: 'openNewApplication', // state to track open/close of this branch
    icon: Add,
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ],
    views: [
      {
        path: '/newapplication/general',
        name: 'General Application',
        // mini: 'GAT',
        icon: LooksOne,
        component: GeneralApplicationTemplate
      },
      {
        path: '/newapplication/toa',
        name: 'TimeOff Application',
        // mini: 'TOA',
        icon: LooksTwo,
        component: TimeOff
      },
      {
        path: '/newapplication/bta',
        name: 'Business Travel',
        icon: LooksThree,
        component: BusinessTravelApplication
      }
    ]
  },
  {
    collapse: true,
    path: '/yourapplication',
    // name: 'Your Application',
    name: 'My Application',
    state: 'openYourApplication', // state to track open/close of this branch
    icon: MyLocation,
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ],
    views: [
      {
        path: '/yourapplication/draft',
        name: 'Drafts',
        mini: '',
        icon: Brightness3,
        render: props => <ApplicationTable {...props} scope='requested' status='draft' />
      },
      {
        path: '/yourapplication/inprogress',
        name: 'In Progress',
        mini: '',
        icon: Brightness2,
        render: props => <ApplicationTable {...props} scope='requested' status='submitted' />
      },
      {
        path: '/yourapplication/completed',
        name: 'Completed',
        mini: '',
        icon: Brightness1,
        render: props => <ApplicationTable {...props} scope='requested' status='finished' />
      }
    ]
  },
  {
    path: '/applications/waitingforcomments',
    // name: 'Waiting For Comments',
    name: 'I am Invited',
    title: 'Applications I am invited to participate',
    icon: Comment,
    render: props => <ApplicationTable {...props} scope='waitingForComments' status='submitted' />, //charts
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ]
  },
  {
    path: '/applications/approved',
    name: 'I Approved',
    title: 'Applications I have approved',
    icon: EventAvailable,
    //component: ApplicationTable, //charts
    //render: props => <ApplicationTable {...props} scope="related" status="completed" />, //charts
    render: props => <ApplicationTable {...props} scope='approved' status='submitted' />, //charts
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ]
  },
  {
    path: '/applications/rejected',
    name: 'I Rejected',
    title: 'Applications I have rejected',
    icon: EventBusy,
    //render: props => <ApplicationTable {...props} scope="related" status="rejected" />, //charts
    render: props => <ApplicationTable {...props} scope='rejected' />,
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ]
  },
  {
    path: '/applications/completed',
    name: 'All Signed',
    title: 'Applications have been approved by all the signers or rejected by any of them',
    icon: EventNote,
    render: props => <ApplicationTable {...props} scope='related' status='finished' />, //charts
    forWhom: [
      UserEnum.ADMIN,
      UserEnum.SUPER,
      UserEnum.USER,
      UserEnum.ExpenseDocumentReceiver,
      UserEnum.ProcurementDocumentReceiver,
      UserEnum.HRDocumentReceiver
    ]
  },
  {
    path: '/applications/inprogress',
    name: 'Applications in Progress',
    title: 'Applications in progress to be followed up later',
    icon: LockOpen,
    render: props => <ApplicationTable {...props} scope='inprogress' status='inprogress' />, //charts
    forWhom: [UserEnum.ExpenseDocumentReceiver, UserEnum.ProcurementDocumentReceiver, UserEnum.HRDocumentReceiver]
  },
  {
    path: '/applications/finished',
    name: 'Applications to follow up',
    title: 'Applications I need to follow up',
    icon: Lock,
    render: props => <ApplicationTable {...props} scope='finished' status='completed' />, //charts
    forWhom: [UserEnum.ExpenseDocumentReceiver, UserEnum.ProcurementDocumentReceiver, UserEnum.HRDocumentReceiver]
  },
  {
    path: '/applications/archived',
    name: 'Applications Archived ',
    title: 'Archived Applications',
    icon: AllInclusive,
    render: props => <ApplicationTableV2 {...props} scope='archived' status='archived' />, //charts
    forWhom: [UserEnum.ExpenseDocumentReceiver, UserEnum.ProcurementDocumentReceiver, UserEnum.HRDocumentReceiver]
  },
  {
    path: '/applications/all',
    name: 'All Applications',
    icon: AllInclusive,
    render: props => <ApplicationTable {...props} />, //charts
    forWhom: [UserEnum.ADMIN, UserEnum.SUPER]
  },
  //https://tylermcginnis.com/react-router-pass-props-to-components/

  {
    collapse: true,
    path: '/systemadmin',
    name: 'System Settings',
    state: 'openSystemAdmin', // state to track open/close of this branch
    icon: Settings,
    forWhom: [UserEnum.ADMIN, UserEnum.SUPER],
    views: [
      {
        path: '/systemadmin/create-route',
        name: 'Manage Routes',
        title: 'Manage Routes',
        // mini: 'CAR',
        icon: SwapCalls,
        component: RoutingDetails
      },
      {
        path: '/systemadmin/list-routes',
        name: 'List All Routes',
        // mini: 'LAR',
        icon: FormatListNumbered,
        // component: RoutingPage,
        component: RoutingTable
      },
      {
        path: '/systemadmin/create-signingpath',
        name: 'Create Signing Path',
        // mini: 'SPD',
        icon: Share,
        component: SigningPathDetail
      },
      {
        path: '/systemadmin/list-signingpath',
        name: 'List Signing Path',
        // mini: 'LSP',
        icon: Storage,
        component: SigningPathPage
      },
      {
        path: '/systemadmin/exrates',
        name: 'Exchange Rates',
        // mini: 'LSP',
        icon: AttachMoneyIcon,
        component: ExRates
      }
    ]
  },
  {
    collapse: true,
    path: '/administration',
    name: 'User Management',
    state: 'openUserAdmin', // state to track open/close of this branch
    icon: People,
    forWhom: [UserEnum.SUPER, UserEnum.ADMIN],
    //how to prevent different routes sharing the same set of chars in the path, they will all light up
    views: [
      {
        path: '/administration/createuser',
        name: 'Create User',
        // mini: 'UP',
        icon: PersonAdd,
        component: UserProfile
      },
      {
        path: '/administration/allusers',
        name: 'List All Users',
        // mini: 'LU',
        icon: PeopleOutline,
        component: UsersAll
      },
      {
        path: '/administration/companies',
        name: 'Manage Companies',
        // mini: 'MC',
        icon: Bookmarks,
        component: CompanyPage
      },
      {
        path: '/administration/departments',
        name: 'Manage Departments',
        // mini: 'MD',
        icon: Bookmark,
        component: DepartmentPage
      },
      {
        path: '/administration/usergroups',
        name: 'Manage User Groups',
        // mini: 'MG',
        icon: FolderShared,
        component: UserGroupPage
      }
    ]
  },
  {
    redirect: true,
    path: '/',
    pathTo: '/dashboard',
    name: 'Dashboard',
    forWhom: [UserEnum.ADMIN, UserEnum.SUPER, UserEnum.GUEST, UserEnum.USER]
  }
]
export default dashRoutes
